// extracted by mini-css-extract-plugin
module.exports = {"container":"TaskActor-module__container--1GxH8","avatar":"TaskActor-module__avatar--2jSj6","name":"TaskActor-module__name--2rR1G"};